import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { MiningPatternDocument, miningPatternPullQueryBuilder } from './queryBuilder';

export function miningPatternFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<MiningPatternDocument> {
  const syncConfig = configBuilder<MiningPatternDocument>(RxdbCollectionNameV2.MINING_PATTERN);
  doNotAutoSync(syncConfig);

  pull(syncConfig, miningPatternPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.MINING_PATTERN, replicationState, [sites]);
}
